import React, { useState } from "react";
import { Box, Container, Tab, Tabs, Typography, Grid, Card, CardContent, CardMedia, IconButton, Fade } from "@mui/material";
import { styled } from "@mui/system";

import UnifyDataPhoto from "./../assets/Homepage - Unify Data.png";
import CutOutNoise from "./../assets/Homepage - Cut Out Noise.png";
import SyncMailboxes from "./../assets/Homepage - Sync Mailboxes.png";
import Automation from "./../assets/Homepage - Automation.png";
import ProjectManagement from "./../assets/Homepage - Project Management.png";



const StyledCard = styled(Card)(({ theme }) => ({
    height: "100%",
    display: "flex",
    flexDirection: "column",
}));

const FeatureTab = styled(Tab)(({ theme }) => ({
    minHeight: 72,
    fontSize: "18px",
    '@media (max-width: 600px)': {
        fontSize: '14px',
    },
    textTransform: "none",
    fontWeight: 600,
    color: "#3b0e59",
    "&.Mui-selected": {
        color: "#6841f2"
    }
}));

const features = [
    {
        title: "Unify Your Data",
        description: [
            "Combine your data sources into a single platform. Access all your information in one place and make better decisions faster, and collaborate with your team in real-time.", 
            "See a record of your communication and activity history on each record. Keep track of your interactions and stay up-to-date with your clients.",
        ],
        image: UnifyDataPhoto
    },
    {
        title: "Cut Out Noise",
        description: [
            "Customize your workspace with personalized views tailored to your needs. Create unique layouts and arrangements that enhance your productivity.",
            "Filter out the noise and focus on what matters. Use advanced search and filtering options to find the information you need quickly.",
        ], 
        image: CutOutNoise
    },
    {
        title: "Automate Workflows",
        description: [
            "Design a custom workflow that fits your business pipeline. Create a smooth customer journey that guides your clients through each stage of the process.",
            "Reduce repetitive tasks and eliminate manual data entry. Automate your processes to save time and increase efficiency.",
        ],
        image: Automation
    },
    {
        title: "Manage Projects",
        description: [
            "Organize your projects and tasks in one place. Keep track of your progress and stay on top of your deadlines.",
            "View your project timeline and milestones at a glance. Monitor your team’s performance and allocate resources effectively.",
        ],
        image: ProjectManagement
    },
    {
        title: "Sync Mailboxes",
        description: [
            "Integrate your email accounts with your CRM. Sync your mailboxes to access your emails directly from your CRM platform.",
            "Keep track of your communication history and maintain a record of your interactions. Delegate tickets and assign tasks to your team.",
        ],
        image: SyncMailboxes
    }
];

const FeatureOverview = () => {
    const [value, setValue] = useState(0);

    const handleChange = (_event: any, newValue: any) => {
        setValue(newValue);
    };

    return (
        <Container sx={{ pt: 4, pb: 4 }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 4 }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="feature tabs"
                    sx={{ 
                        mb: 2,
                        // Change the underline colour
                        "& .MuiTabs-indicator": {
                            backgroundColor: "#6841f2"
                        }
                    }}
                >
                    {features.map((feature, index) => (
                        <FeatureTab
                            key={index}
                            //   icon={<feature.icon size={24} />}
                            label={feature.title}
                            iconPosition="start"
                        />
                    ))}
                </Tabs>
            </Box>

            {features.map((feature, index) => (
                <Fade key={index} in={value === index} timeout={300}>
                    <Box hidden={value !== index}>
                        <Grid container spacing={4} alignItems="flex-start">
                            <Grid item xs={12} md={6}>
                                <StyledCard>
                                <CardMedia
                                    component="img"
                                    height="400"
                                    image={feature.image}
                                    alt={feature.title}
                                    loading="lazy"
                                />
                                </StyledCard>
                            </Grid>
                            <Grid item xs={12} md={6} textAlign="left">
                                <Typography fontFamily="Red Rose" color="#6841f2" fontSize="32px" variant="h5" gutterBottom sx={{ 
                                    fontWeight: 600,
                                    '@media (max-width: 600px)': {
                                        fontSize: '24px',
                                    },
                                }}>
                                    {feature.title}
                                </Typography>
                                {
                                    feature.description.map((desc, index) => (
                                        <Typography fontFamily="Raleway" color="#212529" fontSize="18px" variant="body1" mt={ index === 0 ? undefined : 2 } sx={{
                                            '@media (max-width: 600px)': {
                                                fontSize: '14px',
                                            },
                                        }}>
                                            { desc }
                                        </Typography>
                                    ))
                                }
                            </Grid>
                        </Grid>
                    </Box>
                </Fade>
            ))}
        </Container>
    );
};

export default FeatureOverview;